import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { getCoursePlans } from "../services/school/CoursePlans";

export const useGetCoursePlansQuery = (data: PagedRequestType, options: any = null) =>
    useQuery(
        ["course-plans-pagination", JSON.stringify(data)],
        () => getCoursePlans(data),
        options ? { ...options } : {}
    );